var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { TipoDocumentoEnum } from '../../../../model/enums/TipoDocumentoEnum';
import { PessoaFisicaForm } from '../PessoaFisicaForm/PessoaFisicaForm';
import { PessoaJuridicaForm } from '../PessoaJuridicaForm/PessoaJuridicaForm';
import { ShowContent } from '../../../../components/ShowContent';
import { useRequerimentoContext } from '../context/RequerimentoContext';
import { TipoRequerente } from './TipoRequerente';
import { TipoRequerenteDoc } from './TipoRequerenteDoc';
import { DefaultCard } from '../../../../components/DefaultCard';
export var DadosRequerente = function (_a) {
    var requerimentoFieldErrorChange = _a.requerimentoFieldErrorChange, requerimentoFieldError = _a.requerimentoFieldError, tipoRequerimento = _a.tipoRequerimento, requerimento = _a.requerimento, onValidate = _a.onValidate, invertido = _a.invertido, onChange = _a.onChange;
    var verifyTipDoc = useRequerimentoContext().verifyTipDoc;
    return (_jsxs(_Fragment, { children: [_jsx(DefaultCard, __assign({ title: "" }, { children: _jsx(TipoRequerenteDoc, { requerimentoFieldErrorChange: requerimentoFieldErrorChange }) })), _jsx(DefaultCard, __assign({ title: "" }, { children: _jsx(TipoRequerente, { requerimentoFieldErrorChange: requerimentoFieldErrorChange }) })), _jsx(ShowContent, __assign({ show: verifyTipDoc(TipoDocumentoEnum.PF) }, { children: _jsx(PessoaFisicaForm, { onValidate: function (calback) { return onValidate === null || onValidate === void 0 ? void 0 : onValidate(calback); } }) })), _jsx(ShowContent, __assign({ show: verifyTipDoc(TipoDocumentoEnum.PJ) }, { children: _jsx(PessoaJuridicaForm, { onValidate: function (calback) { return onValidate === null || onValidate === void 0 ? void 0 : onValidate(calback); } }) }))] }));
};
